import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AnnouncementModal from "./AnnouncementModal";
import useAnnouncement from "./hooks/useAnnouncement";
import { ANNOUNCEMENTS } from "./hooks/announcements";

// 1. Create a tiny wrapper to handle the hook logic for EACH announcement
function AnnouncementManager({ data, onTrigger }) {
  const state = useAnnouncement(data.key);
  const { pathname } = useLocation();

  useEffect(() => {
    // Check if the current URL matches the pattern (e.g., /dashboard/league/:id)
    const isMatch = !data.path || pathname.startsWith(data.path);

    if (state.open && isMatch) {
      onTrigger({ ...data, ...state });
    }
  }, [state, pathname, data, onTrigger]);

  return null;
}

export default function AnnouncementCenter() {
  const [activeQueue, setActiveQueue] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [open, setOpen] = useState(false);

  // 2. Add announcements to the local queue when their hook says they should be "open"
  const handleTrigger = (fullAnnouncement) => {
    setActiveQueue((prev) => {
      // Avoid duplicates
      if (prev.find((a) => a.key === fullAnnouncement.key)) return prev;
      return [...prev, fullAnnouncement];
    });
    setOpen(true);
  };

  const handleAcknowledge = () => {
    const current = activeQueue[currentIndex];
    current.acknowledge();

    if (currentIndex < activeQueue.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      setOpen(false);
    }
  };

  const current = activeQueue[currentIndex];

  return (
    <>
      {/* 3. Render the managers for ALL possible announcements at the top level */}
      {ANNOUNCEMENTS.map((a) => (
        <AnnouncementManager key={a.key} data={a} onTrigger={handleTrigger} />
      ))}

      {open && current && (
        <AnnouncementModal
          open={open}
          acknowledge={handleAcknowledge}
          title={current.title}
          message={current.message}
          image={current.image}
          image2={current.image2}
          imageStyle={current.imageStyle}
          showCard={current.showCard}
        />
      )}
    </>
  );
}
